import { useMeta, useContext } from '@nuxtjs/composition-api';
import { mergeHeadItems } from '@/modules/common/utils/helpers';
import {
  generateNewsMediaOrganizationSchema,
  generateSiteNavigationElementSchema,
  generateWebsiteSchema,
  getSchemaHead,
} from '~/modules/common/utils/schemaUtils';
import { GAMES_PATH, HOST_URL } from '~/constants/config';
import { getMetaOpenGraph, getMetaTwitter } from '~/modules/common/utils/metaUtils';

export function useGameMeta({ game = {}, path } = {}) {
  const { i18n } = useContext();
  useMeta(() => {
    let title = `${i18n.t('game.play-with-onedio')}`;
    let description = `${i18n.t('game.discover-with-onedio')}`;
    let url = `${HOST_URL}/${GAMES_PATH}`;
    let imageUrl = 'https://static-onedio.s3.eu-west-1.amazonaws.com/img/jpg/onedio-oyun.jpg';

    // single game meta
    if (game && game.id) {
      title = `${game.name} - ${i18n.t('game.onedio-game')}`;
      description = `${game.name} ${i18n.t('game.click-play')}`;
      url = `${HOST_URL}/${GAMES_PATH}/${game.slug}`;
      imageUrl = game.coverImage;
    }

    // previous games cases
    if (path === '/skor/emojile') {
      title = 'Onedio Emojile Tüm Sorular';
      description = 'Onedio Emojile ile geçmiş tüm Wordle arşivi sizinle. Tümünü keşfetmek için hemen tıkla!';
      imageUrl = 'https://static-onedio.s3.eu-west-1.amazonaws.com/img/jpg/emojile-gecmis-oyunlar.jpg';
      url = `${HOST_URL}/${GAMES_PATH}${path}`;
    } else if (path === '/skor/bilpop') {
      title = 'Onedio Bilpop Tüm Sorular';
      description =
        'Onedio Bilpop geçmiş oyunları şimdi sizinle! Daha fazla en popüler doğru cevapları tahminlerinle keşfetmek için hemen tıkla.';
      imageUrl = 'https://static-onedio.s3.eu-west-1.amazonaws.com/img/jpg/bilpop-gecmis-oyunlar.jpg';
      url = `${HOST_URL}/${GAMES_PATH}${path}`;
    }

    // leaderboard meta
    if (path === '/leaderboard/emojile') {
      title = 'Onedio Emojile Sıralamalar';
      description =
        'Onedio Emojile Sıralamaları ve diğer rakiplerle arandaki farkı görmek için hemen tıkla! Günlük, haftalık ve aylık puanını hemen keşfet.';
      imageUrl = 'https://static-onedio.s3.eu-west-1.amazonaws.com/img/jpg/emojile-liderlik.jpg';
      url = `${HOST_URL}/${GAMES_PATH}${path}`;
    } else if (path === '/leaderboard/bilpop') {
      title = 'Onedio Bilpop Sıralamalar';
      description =
        'Onedio Bilpop sıralamalarındaki yerini keşfetmek ister misin? Bilpop heyecanı şimdi daha rekabetçi! Keşfetmek için hemen tıkla.';
      imageUrl = 'https://static-onedio.s3.eu-west-1.amazonaws.com/img/jpg/bilpop-liderlik.jpg';
      url = `${HOST_URL}/${GAMES_PATH}${path}`;
    }
    const descriptionMeta = { hid: 'description', name: 'description', content: description };
    // meta
    const meta = [
      descriptionMeta,
      ...getMetaOpenGraph({ url, description, title, imageUrl }),
      ...getMetaTwitter({ url, description, title, imageUrl }),
    ];
    // link
    const link = [{ hid: 'canonical', rel: 'canonical', href: url }];
    // schema
    const websiteSchema = generateWebsiteSchema();
    const newsMediaOrganization = generateNewsMediaOrganizationSchema();
    const siteNavigationElementSchema = generateSiteNavigationElementSchema();

    return mergeHeadItems(
      { title },
      { meta },
      { link },
      getSchemaHead(websiteSchema),
      getSchemaHead(newsMediaOrganization),
      getSchemaHead(siteNavigationElementSchema)
    );
  });
}
